// Customer reviews shown in the scrolling testimonials band.
//
// `verified: true` entries are REAL reviews sourced from public listings
// (Uber Eats, Yelp). The rest are SAMPLE placeholders — replace them with
// your real Google / Yelp reviews before publishing (keep 6+ for a full
// scrolling row). Edit here; the component picks them up automatically.

export interface Review {
  quote: string;
  author: string;
  meta: string; // location or context
  source: 'Google' | 'Yelp' | 'Uber Eats' | 'DoorDash';
  rating: number; // 1–5
  verified?: boolean;
}

export const REVIEWS: Review[] = [
  {
    quote: 'New management, authentic South Indian, good service. The Seeraga samba biryani was mouth-watering.',
    author: 'Vamsi C.',
    meta: 'Irving, TX',
    source: 'Yelp',
    rating: 5,
    verified: true,
  },
  {
    quote: 'Very professional delivery and Parotta Express is always our favorite.',
    author: 'Vidyasagar S.',
    meta: 'Coppell, TX',
    source: 'Uber Eats',
    rating: 5,
    verified: true,
  },
  // ── Sample placeholders — replace with your real reviews ──
  {
    quote: 'The parottas are unbelievably flaky and the chicken salna has that proper Chettinad kick. Tastes just like back home.',
    author: 'Priya R.',
    meta: 'Coppell, TX',
    source: 'Google',
    rating: 5,
  },
  {
    quote: 'Ordered the Dindugal mutton biryani and the kothu parotta — both were fantastic. Generous portions and real spice.',
    author: 'Arjun M.',
    meta: 'Irving, TX',
    source: 'Google',
    rating: 5,
  },
  {
    quote: 'Crispy dosa, hot filter coffee, and the friendliest staff. This is my new weekend spot.',
    author: 'Deepa K.',
    meta: 'Las Colinas, TX',
    source: 'Google',
    rating: 5,
  },
  {
    quote: 'Finally, authentic Tamil-style food in the area. The Ceylon veechu parotta is a must-try.',
    author: 'Karthik V.',
    meta: 'Grapevine, TX',
    source: 'Google',
    rating: 5,
  },
  {
    quote: 'Everything is made fresh and you can taste it. The veg thali is incredible value for how much you get.',
    author: 'Sneha T.',
    meta: 'Lewisville, TX',
    source: 'Yelp',
    rating: 5,
  },
  {
    quote: 'Chilli parotta and a mango lassi — perfect. Quick pickup and always consistent.',
    author: 'Rahul B.',
    meta: 'Coppell, TX',
    source: 'DoorDash',
    rating: 4,
  },
];

export const RATING_SUMMARY = {
  label: 'Loved across Coppell',
  detail: 'Rated by diners on Uber Eats, Yelp & Google',
};
